import React from 'react';
import { useRespondToRequestMutation } from '../../../redux/apis/endpoints/messageApi';
import ProductPreview from './ProductPreview';

const OfferMessage = ({ message, isCurrentUser }) => {
  const [respondToOffer, { isLoading }] = useRespondToRequestMutation();
  
  const offerPrice = message.offerPrice || (message.status && message.status.offerPrice);
  const productInfo = message.product;
  const isPending = !message.status || !message.status.responded;
  const isAccepted = message.status && message.status.accepted;
  
  const handleAccept = async () => {
    if (isLoading) return;
    try {
      await respondToOffer({
        messageId: message.id,
        accepted: true,
        responseMessage: `Offer of $${offerPrice} accepted`
      }).unwrap();
    } catch (error) {
      console.error('Failed to accept offer:', error);
    }
  };
  
  const handleDecline = async () => {
    if (isLoading) return;
    try {
      await respondToOffer({
        messageId: message.id,
        accepted: false,
        responseMessage: `Offer of $${offerPrice} declined`
      }).unwrap();
    } catch (error) {
      console.error('Failed to decline offer:', error);
    }
  };
  
  return (
    <div className="offer-message">
      <div className="text-sm font-medium text-indigo-600 mb-2">
        {isCurrentUser ? 'You made an offer' : 'Offer received'}
      </div>
      
      {productInfo && (
        <ProductPreview product={productInfo} isSmall />
      )}
      
      <div className="mt-2 p-3 bg-white rounded-md border border-gray-200">
        <div className="flex justify-between items-center">
          <span className="text-sm font-medium text-gray-700">Offer amount:</span>
          <span className="text-sm font-bold text-green-600">${offerPrice}</span>
        </div>
        
        <div className="text-xs text-gray-500 mt-1">
          {message.messageText}
        </div>
        
        {/* Status indicator */}
        {!isCurrentUser && isPending && (
          <div className="mt-3 flex justify-end space-x-2">
            <button
              type="button"
              onClick={handleDecline}
              disabled={isLoading}
              className="px-3 py-1 text-xs font-medium rounded-md bg-white border border-gray-300 text-gray-700 hover:bg-gray-50"
            >
              Decline
            </button>
            <button
              type="button"
              onClick={handleAccept}
              disabled={isLoading}
              className="px-3 py-1 text-xs font-medium rounded-md bg-indigo-600 text-white hover:bg-indigo-700"
            >
              Accept
            </button>
          </div>
        )}
        
        {!isPending && (
          <div className={`mt-2 text-xs font-medium ${isAccepted ? 'text-green-600' : 'text-red-600'}`}>
            {isAccepted ? 'Offer accepted' : 'Offer declined'}
          </div>
        )}
      </div>
    </div>
  );
};

export default OfferMessage; 